import React, { Component } from "react";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleRadio from "../../../../modules/SimpleRadio";
import {
  ENUM_TIPE_FJB,
  FAKTUR_JUAL_BENGKEL_KATEGORI,
  TIPE_FJB_OPTIONS,
} from "../constant";
import ModalHotline from "./modal/modalHotline";
import ModalBooking from "./modal/modalBooking";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import ModalProspect from "./modal/modalProspect";
import { mapToObjectDDL } from "../../../common/mapper";
import ModalClaim from "./modal/modalClaim";
import { initialDataAnalisa, initialDataPemilik, initialDataTambahan, initialDataTransaksi, initialDataUnit } from "../config/formConfig";

class FakturJualBengkelHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalHotlineVisible: false,
      modalBookingVisible: false,
      modalProspectVisible: false,
      modalClaimVisible: false,
      mechanicNameOptions: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const currTipeFjb = this.props.formData?.tipeFjb?.value;
    const prevTipeFjb = prevProps.formData?.tipeFjb?.value;
    if (
      currTipeFjb !== prevTipeFjb &&
      currTipeFjb === ENUM_TIPE_FJB.JOB_RETURN
    ) {
      this.fetchDataMechanic();
    }
  }

  handleModalVisibility = (name) => {
    this.setState((prev) => ({
      ...prev,
      [name]: !prev?.[name],
    }));
  };

  fetchDataMechanic = async () => {
    const { onTriggerLoading, setError, formData } = this.props;
    const kodeCabang = formData?.kodeCabang;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMechanicNameFjb,
      menuName: "Faktur Jual Bengkel",
      setError: setError,
      args: {
        cabang: [kodeCabang?.value],
      },
    });
    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        mechanicNameOptions: res.data.data.map((item) =>
          mapToObjectDDL(item.name, item.employeeId)
        ),
      });
    }
  };

  handleChangeTipeFjb = (name, value) => {
    const { onChangeData } = this.props;

    onChangeData("mekanikSebelumnya", null);
    onChangeData("claimNo", null);
    onChangeData(name, value);
  };

  handleChangeFjbCategory = (item)=> {
    const { onChangeData,onSetState } = this.props
    if(item?.value === "DIRECT_SALES"){
      onSetState((prevState) => ({
          ...prevState,
          data: {
              ...prevState.data,
              dataTransaksi: initialDataTransaksi,
              dataUnit: initialDataUnit,
              dataPemilik: initialDataPemilik,
              dataAnalisa: initialDataAnalisa,
              dataTambahan: initialDataTambahan,
          }
      }))
    }
    onChangeData("kategoriFakturJualBengkel", item)
  }

  render() {
    const { errors, cabangOptions, formData, onChangeData, activityType } =
      this.props;
    const {
      modalHotlineVisible,
      modalBookingVisible,
      modalProspectVisible,
      modalClaimVisible,
      mechanicNameOptions,
    } = this.state;
    const isReadOnly = activityType === ACTIVITY_TYPE.VIEW;

    return (
      <React.Fragment>
        <div className="grid grid-2x grid-mobile-none gap-15px">
          <div id="grid-1">
            <SimpleDDL
              id="select_options_cabang"
              box="search"
              name="kodeCabang"
              label="Cabang"
              placeholder="Cabang"
              mandatory
              isClearable
              readOnly={isReadOnly}
              errorMessage={errors?.kodeCabang}
              options={cabangOptions}
              value={formData?.kodeCabang}
              onChange={(value, { name }) => onChangeData(name, value)}
            />
            <SimpleInput
              id="input_text_no_faktur_jual"
              name="noFakturJualBengkel"
              label="No. Faktur Jual Bengkel"
              containerclassname="margin margin-top-25px"
              readOnly
              value={formData?.noFakturJualBengkel}
            />
            <SimpleDate
              id="select_date_tanggal_faktur_jual"
              label="Tanggal Faktur Jual Bengkel"
              name="tanggalFakturJualBengkel"
              disabled
              date={formData?.tanggalFakturJualBengkel}
            />
            <div
              className="display-flex-normal margin-top-30px"
              style={{ gap: "15px" }}
            >
              {FAKTUR_JUAL_BENGKEL_KATEGORI.map((item) => (
                <SimpleRadio
                  id={`radio_button_${item.label}`}
                  key={`radio_${item.label}`}
                  active={
                    formData?.kategoriFakturJualBengkel?.value === item.value
                  }
                  disabled={isReadOnly}
                  option={item.label}
                  onChange={() =>
                    this.handleChangeFjbCategory(item)
                  }
                />
              ))}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <SimpleInput
                id="input_text_no_hotline"
                name="noHotline"
                label="No. Hotline"
                containerclassname="width width-full"
                readOnly
                value={formData?.noHotline}
              />
              <SimpleButton
                category="action_button"
                className="margin margin-top-10px"
                disabled={isReadOnly}
                icon={<i className="fa fa-search" style={{ fontSize: 20 }} />}
                onClick={() =>
                  this.handleModalVisibility("modalHotlineVisible")
                }
              />
              <SimpleButton
                category="action_button"
                disabled={isReadOnly}
                className="margin margin-top-10px"
                icon={<i className="fa fa-lg fa-times" />}
                onClick={() => onChangeData("noHotline", null)}
              />
            </div>
          </div>
          <div id="grid-2">
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <SimpleInput
                id="input_text_no_indent"
                name="noBooking"
                label="No. Booking"
                containerclassname="width width-full"
                readOnly
                value={formData?.noBooking}
              />
              <SimpleButton
                category="action_button"
                className="margin margin-top-10px"
                disabled={isReadOnly}
                icon={<i className="fa fa-search" style={{ fontSize: 20 }} />}
                onClick={() =>
                  this.handleModalVisibility("modalBookingVisible")
                }
              />
              <SimpleButton
                category="action_button"
                className="margin margin-top-10px"
                disabled={isReadOnly}
                icon={<i className="fa fa-lg fa-times" />}
                onClick={() => onChangeData("noBooking", null)}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <SimpleInput
                id="input_text_no_prospect"
                name="noProspect"
                label="No. Prospect"
                containerclassname="width width-full"
                readOnly
                value={formData?.noProspect}
              />
              <SimpleButton
                category="action_button"
                className="margin margin-top-10px"
                disabled={isReadOnly}
                icon={<i className="fa fa-search" style={{ fontSize: 20 }} />}
                onClick={() =>
                  this.handleModalVisibility("modalProspectVisible")
                }
              />
              <SimpleButton
                category="action_button"
                className="margin margin-top-10px"
                disabled={isReadOnly}
                icon={<i className="fa fa-lg fa-times" />}
                onClick={() => onChangeData("noProspect", null)}
              />
            </div>
            <SimpleInput
              id="input_text_jenis_prospect"
              name="jenisProspect"
              label="Jenis Prospect"
              readOnly
              value={formData?.jenisProspect}
            />
            <SimpleDDL
              id="select_options_tipe_fjb"
              box="search"
              name="tipeFjb"
              label="Tipe FJB"
              placeholder="Tipe FJB"
              mandatory
              isClearable
              readOnly={isReadOnly}
              errorMessage={errors?.tipeFakturJualBengkel}
              options={TIPE_FJB_OPTIONS}
              value={formData?.tipeFjb}
              onChange={(value, { name }) => {
                this.handleChangeTipeFjb(name, value);
              }}
            />
            {[ENUM_TIPE_FJB.C1, ENUM_TIPE_FJB.C2].includes(
              formData?.tipeFjb?.value
            ) && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <SimpleInput
                  id="input_text_no_claim"
                  name="claimNo"
                  label="No. Claim"
                  containerclassname="width width-full"
                  readOnly
                  value={formData?.claimNo}
                />
                <SimpleButton
                  category="action_button"
                  className="margin margin-top-10px"
                  icon={<i className="fa fa-search" style={{ fontSize: 20 }} />}
                  onClick={() =>
                    this.handleModalVisibility("modalClaimVisible")
                  }
                />
                <SimpleButton
                  category="action_button"
                  disabled={isReadOnly}
                  className="margin margin-top-10px"
                  icon={<i className="fa fa-lg fa-times" />}
                  onClick={() => onChangeData("claimNo", null)}
                />
              </div>
            )}
            {formData?.tipeFjb?.value === ENUM_TIPE_FJB.JOB_RETURN && (
              <SimpleDDL
                id="dropdown_mekanik_sebelumnya"
                name="mekanikSebelumnya"
                label="Mekanik Sebelumnya"
                containerclassname="width width-full"
                options={mechanicNameOptions}
                box="search"
                readOnly={isReadOnly}
                onChange={(value, { name }) => onChangeData(name, value)}
                value={formData?.mekanikSebelumnya}
              />
            )}
          </div>
        </div>
        {modalHotlineVisible && (
          <ModalHotline
            visible={modalHotlineVisible}
            onClickClose={() =>
              this.handleModalVisibility("modalHotlineVisible")
            }
          />
        )}
        {modalBookingVisible && (
          <ModalBooking
            {...this.props}
            visible={modalBookingVisible}
            onClickClose={() =>
              this.handleModalVisibility("modalBookingVisible")
            }
          />
        )}
        {modalProspectVisible && (
          <ModalProspect
            {...this.props}
            visible={modalProspectVisible}
            onClickClose={() =>
              this.handleModalVisibility("modalProspectVisible")
            }
          />
        )}
        {modalClaimVisible && (
          <ModalClaim
            {...this.props}
            visible={modalClaimVisible}
            onClickClose={() => this.handleModalVisibility("modalClaimVisible")}
          />
        )}
      </React.Fragment>
    );
  }
}

export default FakturJualBengkelHeader;
